import script from "./LoadingData.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingData.vue?vue&type=script&setup=true&lang=js"

import "./LoadingData.vue?vue&type=style&index=0&id=108d7f72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108d7f72"]])

export default __exports__